import { Link } from 'react-router-dom'

const C = { primary: '#206bc4', dark: '#0f172a', gray50: '#f8fafc', gray200: '#e2e8f0', gray400: '#94a3b8', gray500: '#64748b', gray600: '#475569', white: '#fff' }

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 28 }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, color: C.dark, marginBottom: 8 }}>{title}</h2>
      <div style={{ fontSize: 14, color: C.gray600, lineHeight: 1.8 }}>{children}</div>
    </div>
  )
}

export default function TermsPage() {
  return (
    <div style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif", minHeight: '100vh', background: C.gray50 }}>
      <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 5%', maxWidth: 1000, margin: '0 auto' }}>
        <Link to="/landing" style={{ display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}>
          <div style={{ width: 28, height: 28, borderRadius: 6, background: C.primary, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 900, fontSize: 14 }}>L</div>
          <span style={{ fontWeight: 800, fontSize: 18, color: C.dark }}>Leadiox</span>
        </Link>
        <Link to="/login" style={{ fontSize: 14, color: C.gray500, textDecoration: 'none' }}>Sign In</Link>
      </nav>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '20px 5% 60px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: C.dark, marginBottom: 4 }}>Terms of Service</h1>
        <p style={{ fontSize: 13, color: C.gray400, marginBottom: 32 }}>Last updated: February 2026</p>

        <Section title="1. Agreement to Terms">
          <p>By accessing or using Leadiox ("Service"), operated by Delvios LLC ("we," "us," "our"), you agree to be bound by these Terms of Service. If you do not agree, you may not use the Service.</p>
        </Section>

        <Section title="2. Description of Service">
          <p>Leadiox is a cloud-based customer relationship management (CRM) platform designed for hotel sales and catering teams. The Service includes lead management, event planning, proposal generation, banquet event orders, invoicing, reporting, and related tools.</p>
        </Section>

        <Section title="3. Accounts & Registration">
          <p>You must provide accurate and complete information when creating an account. You are responsible for maintaining the security of your account credentials and for all activity under your account. You must notify us immediately of any unauthorized use.</p>
        </Section>

        <Section title="4. Subscriptions & Billing">
          <p>Leadiox offers paid subscription plans billed monthly. By subscribing, you authorize us to charge your payment method through our payment processor, LemonSqueezy, on a recurring monthly basis. All new subscriptions include a 14-day money-back guarantee from the date of purchase. If you are not satisfied within 14 days, contact us for a full refund.</p>
          <p style={{ marginTop: 8 }}>After 14 days, you may cancel your subscription at any time through your account settings. Upon cancellation, you will retain access to the Service through the end of your current billing cycle. No refunds are issued for partial months after the 14-day guarantee period. We reserve the right to change pricing with 30 days' notice.</p>
        </Section>

        <Section title="5. Acceptable Use">
          <p>You agree not to: (a) use the Service for any unlawful purpose; (b) attempt to gain unauthorized access to any part of the Service; (c) interfere with or disrupt the Service or its servers; (d) upload malicious code; (e) scrape or harvest data from the Service; (f) resell or sublicense access to the Service without our written consent.</p>
        </Section>

        <Section title="6. Your Data">
          <p>You retain ownership of all data you enter into the Service ("Your Data"). You grant us a limited license to store, process, and display Your Data solely to provide the Service. We will not sell, share, or use Your Data for advertising purposes. When you delete your account, we will delete Your Data within 30 days, except as required by law or for legitimate business purposes (such as fraud prevention).</p>
        </Section>

        <Section title="7. Intellectual Property">
          <p>The Service, including its design, features, code, and documentation, is owned by Delvios LLC and protected by intellectual property laws. You may not copy, modify, distribute, or create derivative works of the Service.</p>
        </Section>

        <Section title="8. Limitation of Liability">
          <p>To the maximum extent permitted by law, Delvios LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly. Our total liability for any claim arising from the Service shall not exceed the amount you paid us in the 12 months preceding the claim.</p>
        </Section>

        <Section title="9. Disclaimer of Warranties">
          <p>The Service is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the Service will be uninterrupted, error-free, or secure. We disclaim all warranties including implied warranties of merchantability and fitness for a particular purpose.</p>
        </Section>

        <Section title="10. Termination">
          <p>We may suspend or terminate your access if you violate these Terms. You may terminate your account at any time by canceling your subscription and contacting us. Upon termination, your right to use the Service ceases immediately.</p>
        </Section>

        <Section title="11. Changes to Terms">
          <p>We may update these Terms from time to time. We will notify you of material changes via email or through the Service. Continued use of the Service after changes become effective constitutes acceptance of the revised Terms.</p>
        </Section>

        <Section title="12. Governing Law">
          <p>These Terms are governed by and construed in accordance with the laws of the State of Georgia, United States, without regard to conflict of law principles.</p>
        </Section>

        <Section title="13. Contact">
          <p>If you have questions about these Terms, please contact us at <a href="mailto:legal@leadiox.com" style={{ color: C.primary }}>legal@leadiox.com</a>.</p>
        </Section>

        <div style={{ marginTop: 40, paddingTop: 20, borderTop: `1px solid ${C.gray200}`, display: 'flex', gap: 20, fontSize: 13, color: C.gray400 }}>
          <Link to="/privacy" style={{ color: C.primary, textDecoration: 'none' }}>Privacy Policy</Link>
          <Link to="/landing" style={{ color: C.gray400, textDecoration: 'none' }}>Back to Home</Link>
        </div>
      </div>
    </div>
  )
}
